import getInfoFromURL from './getInfoFromURL'
import log from '@/shared/logging'
import messages from '@/shared/i18n/messages'

export default function (error) {
  console.log(error, 'This was the error')
  const baseUrl = '/' + getInfoFromURL()[0]

  let errorMessage = ''
  if (error.message) {
    errorMessage = error.message
  } else if (error.data) {
    errorMessage = error.data.message ? error.data.message : ''
  }

  const defaultLang = 'english'
  const lang = window.siteInfo?.lang || defaultLang

  const t = (key) => {
    return messages[lang]?.[key] || messages[defaultLang]?.[key] || key
  }

  window.document.write('<link rel="stylesheet" href="assets/stylesheets/site-zava.css">')
  window.document.write('<i class="Icon Icon-information-circle" ' +
    'style="font-size: 6rem;display: inline-block;text-align: center;width: 100%"></i>')
  window.document.write('<h1 style="text-align: center; padding: 5%;">' + errorMessage + '</h1>')
  window.document.write(
    '<div style="text-align: center; font-size: larger"><a href="' +
      baseUrl +
      '">' +
      t('common_error_viewAllServices') +
      '</a></div>'
  )

  log(errorMessage)
}
